// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1US1p","noInteraction":"EventWrapper_noInteraction__zFFnp","pointerPassthrough":"EventWrapper_pointerPassthrough__1PXn2"};